/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { NotificationType } from "~/generated/graphql";
import { NOTIFICATION_ICON_STATUS } from "~/components";

export function mapNotificationStatus(
  type: NotificationType
): NOTIFICATION_ICON_STATUS {
  switch (type) {
    case NotificationType.Error:
      return NOTIFICATION_ICON_STATUS.ERROR;
    case NotificationType.Info:
      return NOTIFICATION_ICON_STATUS.INFO;
    case NotificationType.Warning:
      return NOTIFICATION_ICON_STATUS.WARNING;
    default:
      throw new Error("Unsupported notification type");
  }
}
